import { useRef } from "react"

import { iconKey } from "@/common/globals"
import { Box, Button, CardContent, Stack, Typography } from "@mui/material"
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos"
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew"
// import { useNavigate } from "react-router-dom"

import { FilterMenuButton } from "../navBar/FilterMenuButton"
import useIsMobile from "@/hooks/useIsMobile"
import { useEventContext } from "@/contexts/EventContext"
import React from "react"
import { useNavBarContext } from "@/contexts/NavBarContext"
import { useGetMe } from "@/hooks/useGetMe"
import LoginDialog from "@/dialogs/events/LoginDialog"
import useDialogState from "@/hooks/useDialogState"
import ReactGA from "react-ga4"
// import useIsTablet from "@/hooks/useIsTablet"

const ArrowButton = ({
  leftOrRight,
  onClick,
}: {
  leftOrRight: string
  onClick: () => void
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      onMouseEnter={(e) => {
        const target = e.target as HTMLElement
        target.style.borderColor = "#FFFFFF"
      }}
      onMouseLeave={(e) => {
        const target = e.target as HTMLElement
        target.style.borderColor = "#000000"
      }}
    >
      {leftOrRight === "left" ? (
        <Button
          onClick={onClick}
          sx={{
            justifyContent: "center",
            alignItems: "center",
            border: "1px solid primary",
            borderRadius: "50%",
            padding: "0.5rem",
            minWidth: "48px",
          }}
        >
          <ArrowBackIosNewIcon />
        </Button>
      ) : (
        <Button
          onClick={onClick}
          sx={{
            justifyContent: "center",
            alignItems: "center",
            border: "1px solid primary",
            borderRadius: "50%",
            padding: "0.5rem",
            minWidth: "48px",
          }}
        >
          <ArrowForwardIosIcon />
        </Button>
      )}
    </div>
  )
}

const MapFilterNavigation = () => {
  const isMobile = useIsMobile()
  // const isTablet = useIsTablet()
  // const navigate = useNavigate()
  const { data: me } = useGetMe()
  const { isHovered } = useNavBarContext()
  const notHoveredStyle = !isHovered && !isMobile

  const { openDialog, ...dialogState } = useDialogState({})

  const { setValue, value } = useEventContext()

  const cellStyle = {
    display: "flex",
    justifyContent: "center",
    height: "100%",
    alignItems: "center",
    paddingLeft: ".5rem",
    margin: 0,
    flexDirection: "column" as const,
    backgroundColor: "transparent",
    paddingX: 4,
    paddingY: 0,
  }

  const pictureStyle = notHoveredStyle
    ? { height: "28px", width: "28px" }
    : isMobile
    ? { height: "30px", width: "30px" }
    : {
        height: "34px",
        width: "34px",
      }

  const cardStyling = {
    border: 0,
    margin: 0,
    padding: 0,
    minWidth: 0,
    minHeight: 0,
    boxShadow: "none",
    maxHeight: "100px",
    alignContent: "center",
  }
  const disabledCardStyling = {
    border: 0,
    margin: 0,
    padding: 0,
    minWidth: 0,
    minHeight: 0,
    boxShadow: "none",
    maxHeight: "100px",
    alignContent: "center",
    color: "text.disabled",
    opacity: "50%",
  }

  const containerRef = useRef<HTMLDivElement>(null)

  const prevHandler = () => {
    if (containerRef.current) {
      containerRef.current.scrollLeft -= 100
    }
  }

  const nextHandler = () => {
    if (containerRef.current) {
      containerRef.current.scrollLeft += 100
    }
  }

  const handleFilterClick = (val: string) => {
    if (val === "favorites" && !me.length) {
      openDialog({})
      return
    }

    const isAdding = !value.includes(val)

    // Track category filter click
    ReactGA.event({
      category: "Filter",
      action: isAdding ? "Add category filter" : "Remove category filter",
      label: `${val} | User: ${me?.id ?? "guest"}`,
    })

    if (value.includes(val)) {
      const newValues = value.filter((value) => val !== value)

      setValue(newValues)
    } else {
      const newValues = [...value, val]
      setValue(newValues)
    }
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingX: isMobile ? ".5rem" : "2rem",
      }}
    >
      {/**
       * type filter
       */}
      {!isMobile && (
        <div>
          <ArrowButton leftOrRight="left" onClick={prevHandler} />
        </div>
      )}
      <Box
        ref={containerRef}
        style={{
          display: "flex",
          overflowX: "scroll",
          overflowY: "hidden",
          alignItems: "center",
          justifyContent: "flex-start",
          marginLeft: ".5rem",
          width: "100%",
          minHeight: "100%",
          maxHeight: "100%",
        }}
      >
        <Stack
          direction="row"
          gap={notHoveredStyle ? 8 : isMobile ? 0 : 5}
          sx={{
            justifyContent: "center",
          }}
        >
          {Object.entries(iconKey).map((filter, idx) => (
            <React.Fragment key={idx}>
              {["attractions", "arrowButton", "filter"].includes(filter[0]) ? (
                <></>
              ) : (
                <Button
                  sx={
                    value.length && !value.includes(filter[0])
                      ? disabledCardStyling
                      : cardStyling
                  }
                  onClick={() => handleFilterClick(filter[0])}
                  key={idx}
                >
                  <CardContent sx={{ border: 0, padding: 0 }}>
                    <div className="cell" style={cellStyle}>
                      <img
                        style={{
                          ...pictureStyle,
                          filter:
                            value.length && !value.includes(filter[0])
                              ? "grayscale(100%)"
                              : "none",
                        }}
                        src={filter[1]}
                        alt={`${filter[0]} in Charleston`}
                      />
                      {notHoveredStyle ? (
                        <></>
                      ) : (
                        <Typography
                          variant={isMobile ? "subtitle2" : "h4"}
                          fontWeight={500}
                        >
                          {`${filter[0][0].toUpperCase()}${filter[0].slice(1)}`}
                        </Typography>
                      )}
                    </div>
                  </CardContent>
                </Button>
              )}
            </React.Fragment>
          ))}
        </Stack>
      </Box>{" "}
      {!isMobile && <ArrowButton leftOrRight="right" onClick={nextHandler} />}
      {/**
       * attractions button
       */}
      {/* <Button
        variant={isHovered ? "outlined" : "text"}
        sx={{
          height: "56px",
          marginLeft: ".5rem",
          marginRight: ".5rem",
          borderRadius: "12px",
        }}
      >
        <Stack
          direction={isMobile ? "column" : "row"}
          paddingX={1}
          gap={1}
          sx={{ alignItems: "center", maxHeight: "56px" }}
          onClick={() => {
            navigate("/attractions")
          }}
        >
          <img
            style={
              isMobile || isTablet
                ? {
                    width: "40px",
                    height: "30px",
                  }
                : isHovered
                ? {
                    width: "60px",
                    height: "40px",
                  }
                : {
                    width: "48px",
                    height: "30px",
                  }
            }
            src={iconKey.attractions}
            alt="Attractions in Charleston"
          />

          <Typography variant={isMobile || isTablet ? "caption" : "subtitle2"}>
            Attractions
          </Typography>
        </Stack>
      </Button> */}
      {/**
       * filter button
       */}
      {!isMobile && <FilterMenuButton />}
      <LoginDialog
        {...dialogState}
        message="Log in to view your favorite events!"
      />
    </Box>
  )
}

export default MapFilterNavigation
